import { RadioTheme } from '../../types';

export const RADIO_DEFAULT_THEME: RadioTheme = {
    colors: {
        default: 'grey.base',
        checked: 'primary.base',
    },
};
